module.exports = __webpack_public_path__ + "static/img/kjdy08.a7f7982.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doubleQianNiu/kjdy08.jpg
// module id = 1421
// module chunks = 0